import { setCookie, parseCookies } from 'nookies'
import { useEffect } from 'react'
import { COOKIE_SHOW_NEW_PORTAL } from '../../utils/redirects'
import { usePortalMigrationEnabled } from '../usePortalMigrationEnabled'

export const useNewPortalRolloutCookie = (): void => {
  const now = Date.now()
  // TODO clean code once login FF is fully rollout IDENTITY-2438
  const loginMigrationEnabled = usePortalMigrationEnabled()
  let showNewPortal: string
  if (loginMigrationEnabled) {
    showNewPortal = 'true'
  } else {
    showNewPortal = parseCookies()[COOKIE_SHOW_NEW_PORTAL] ?? 'false'
  }
  useEffect(() => {
    setCookie(null, COOKIE_SHOW_NEW_PORTAL, showNewPortal, {
      path: '/',
      secure: true,
      sameSite: 'none',
      expires: new Date(now + 1000 * 60 * 60 * 24 * 365),
    })
  }, [now])
}
